package com.volkswagen.vocs.grip.vocstis

import kotlin.String
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
public enum class TariffKind {
  @SerialName(value = "IMPORT")
  Import,
  @SerialName(value = "EXPORT")
  Export,
  ;

  override fun toString(): String = serializer().descriptor.getElementName(ordinal)
}
